import { CategoryApi } from "@/api/CategoryApi";
import { SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { ALL_CATEGORIES_LABEL, ALL_CATEGORIES_OPTION, PRODUCT_REPORT_PROPERTIES, PROPERTY_FIELD_PREFIX } from "@utils/ProductsByCategoryReport";
import { chunkArray } from "@utils/Utils";

const PROPERTIES_PER_ROW = 4;

/** Un checkbox por propiedad del catalogo, en filas de cuatro columnas. */
const propertyFields = chunkArray([...PRODUCT_REPORT_PROPERTIES], PROPERTIES_PER_ROW).map(row => {
    return row.map(property => ({
        "type": "checkbox",
        "name": `${PROPERTY_FIELD_PREFIX}${property.key}`,
        "label": property.label,
        "sizing": {
            "sm": 3
        }
    }));
});

const ProductsByCategoryFormConfig = {
    sections: [
        {
            "fields": [
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "categoryId",
                        "label": "Categoria",
                        "isHorizontal": true,
                        "optionsFunction": async () => {
                            const categories = await CategoryApi.optionsList({ activo: { eq: true } });
                            return {
                                [ALL_CATEGORIES_OPTION]: ALL_CATEGORIES_LABEL,
                                ...categories
                            }
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 9
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "includeInactive",
                        "label": "Incluir productos inactivos",
                        "sizing": {
                            "sm": {
                                "offset": 2
                            }
                        }
                    }
                ],
            ]
        },
        {
            "title": "Propiedades del reporte",
            "fields": propertyFields
        }
    ],
};

export default ProductsByCategoryFormConfig;
